export const StaticAlt = 'ChalkWide'

export function formatDate(isoString) {
  const date = new Date(isoString)
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
}

export const highestInt = 9007199254740991

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

export const yearOptions = Array.from({ length: new Date().getFullYear() - 1999 }, (_, i) => {
  const y = 2000 + i
  return { label: y.toString(), value: y.toString() }
})


export function extractFileName(url) {
  // Method 1: Most reliable (handles query strings, fragments, encoding)
  try {
    const urlObj = new URL(url);
    const path = urlObj?.pathname;
    const fileName = path?.split('/')?.pop(); // get last segment
    return fileName || '';
  } catch (e) {
    // Fallback if URL is malformed
    const parts = url?.split('/');
    let last = parts[parts?.length - 1];

    // Remove query string and fragment if present
    last = last?.split('?')[0]?.split('#')[0];

    return last || '';
  }
}